import classNames from "classnames";
import React from "react";

import SVGIcon from "../../Images/SVGIcon";
import commonStyles from "../../style.module.css";
import NestedDropdownItem from "../NestedDropdownItem";

const DropdownItem = ({
  className,
  children,
  startIcon,
  isSelected = false,
  isNested = false,
  items = [],
  onClick,
  testId,
  nestedDropdownTestId,
  dropdownItemTitleClassName = "",
  endContent = null,
  ...props
}) => {
  if (isNested) {
    return (
      <NestedDropdownItem
        onClick={onClick}
        startIcon={startIcon}
        children={children}
        items={items}
        nestedDropdownTestId={nestedDropdownTestId}
        {...props}
      />
    );
  }

  return (
    <div
      className={classNames(commonStyles.dropdownItem, className, {
        [commonStyles.dropdownItemActive]: isSelected,
      })}
      data-testid={testId}
      {...props}
    >
      <div className={classNames(commonStyles.dropdownItemTitle, dropdownItemTitleClassName)}>
        {startIcon ? <SVGIcon src={startIcon} className={commonStyles.dropdownItemTitleIcon} /> : null}
        <div>{children}</div>
      </div>
      {endContent}
      {isSelected ? (
        <SVGIcon className={commonStyles.dropdownItemIcon} src="components/v2/Filters/Dropdown/tick.svg" />
      ) : null}
    </div>
  );
};

export default DropdownItem;
